export const NAME = 'global';
